import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=15ba494b&"
import script from "./Toolbar.vue?vue&type=script&lang=js&"
export * from "./Toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Toolbar.vue"
export default component.exports